<template>
    <Toggle
        v-model="isDark"
        @toggle="toggleTheme"
        :label="siteContent.darkMode">
    </Toggle>
</template>

<script>
    import { mapActions } from 'vuex'

    export default {
        name: 'SetTheme',
        data() {
            return {
                isDark: null
            }
        },
        methods: {
            ...mapActions('users',['setPreferredTheme']),
            
            toggleTheme() {
                if(this.preferences.theme === 'dark') {
                    this.setPreferredTheme('light')
                    document.documentElement.setAttribute('data-theme', 'light')
                } else {
                    this.setPreferredTheme('dark')
                    document.documentElement.setAttribute('data-theme', 'dark')
                }
            }
        },
        mounted() {
            if(this.preferences.theme === 'dark') {
                this.isDark = true
            } else {
                this.isDark = false
            }
        }
    }
</script>